import * as React from 'react';
import {
  Box,
  TextField,
  TextInput,
} from '@flightstats/airframe-react';
import styles from './TextAreaStyles.module.css';

export const HoneypotInput: React.FC = () => (
  <Box className={styles.hidden}>
    <TextField>
      <TextInput
        id='kwijybo'
        label='kwijybo'
      />
    </TextField>
  </Box>
);